// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"22046606","247":"da3493a1"}[chunkId] + ".chunk.css";
};